import { render, staticRenderFns } from "./addressFormatForm.vue?vue&type=template&id=b95c75b2&"
import script from "./addressFormatForm.vue?vue&type=script&lang=js&"
export * from "./addressFormatForm.vue?vue&type=script&lang=js&"
import style0 from "./addressFormatForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95c75b2')) {
      api.createRecord('b95c75b2', component.options)
    } else {
      api.reload('b95c75b2', component.options)
    }
    module.hot.accept("./addressFormatForm.vue?vue&type=template&id=b95c75b2&", function () {
      api.rerender('b95c75b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/form/addressFormatForm.vue"
export default component.exports